module.exports = __webpack_public_path__ + "fonts/Axiforma-Thin.8b9bce7.ttf";